import { createRoot } from "react-dom/client";
import App from "./App";
import RootLayout from "./components/RootLayout";
import store from "./redux/store/store";
import { Provider } from "react-redux";
import "./index.css";

if (process.env.REACT_APP_DEBUGGER === "true") {
  require("./debugger/bootstrapDebugger");
}

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <RootLayout>
    <Provider store={store}>
      <App />
    </Provider>
  </RootLayout>
);
